export default {"src":"/_next/static/media/arbitrum.8bdc4c9b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};